import type { FpMessage, FpMessagePart } from "../../../../../schemas/codegen";

// Type guard for text parts
const isTextPart = (
  part: FpMessagePart,
): part is Extract<FpMessagePart, { type: "text" }> => part.type === "text";

/**
 * Hook to process message content by combining main content with text parts
 */
export function useMessageContent() {
  const getCombinedMessageContent = (message: FpMessage): string => {
    const textParts = message.parts?.filter(isTextPart) || [];
    const mainContent = message.content?.trim() || "";

    if (textParts.length === 0) {
      return mainContent;
    }

    // Combine main content with text parts chronologically
    const allTextContent = [
      mainContent,
      ...textParts.map((part) => part.content?.trim() || ""),
    ]
      .filter((content) => content.length > 0)
      .join("\n\n");

    return allTextContent;
  };

  return { getCombinedMessageContent };
}
